import { NgModule } from '@angular/core';

import { FileService } from './core';

@NgModule({
    providers: [FileService],
})
export class CmpsObjectStoreModule {}
